<template>
  <v-row>
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <v-row no-gutters class="pr-4">
      <v-col>
        <v-toolbar flat class="sub-toolbar" height="50px">
          <v-toolbar-title class="primary--text">Countries</v-toolbar-title>
          <div class="pl-4">
            <v-btn small outlined color="primary" @click="onNewItem">
              <v-icon>add</v-icon>
            </v-btn>
          </div>
        </v-toolbar>
      </v-col>

      <v-col cols="2" class="d-flex justify-content-center pt-3">
        <input class="form-control" v-model="searchTable" placeholder="Search country" />
      </v-col>

      <v-col class="d-flex justify-content-end pt-3">
        <v-btn
          small
          tile
          depressed
          color="primary"
          class="font-weight-bold text-button"
          @click="loadCountries"
          >LOAD</v-btn
        >
      </v-col>
    </v-row>

    <v-row>
      <v-divider></v-divider>
    </v-row>

    <v-row no-gutters>
      <v-col class="px-2">
        <v-card color="white" flat tile>
          <v-data-table
            dense
            :search="searchTable"
            :items="countries"
            :headers="headers"
            no-data-text="Click load to display countries"
            item-key="code"
          >
            <template v-slot:item="{ item }">
              <tr :key="item.code">
                <td class="caption text-left pl-2">{{ item.name }}</td>
                <td class="caption text-center">{{ item.code }}</td>
                <td class="caption text-left pl-2">
                  <v-row align="center">
                    <v-chip x-small class="pa-1 overline"
                      >{{ item.geocode.geometry.location.lat.toFixed(2) }},
                      {{ item.geocode.geometry.location.lng.toFixed(2) }}</v-chip
                    >
                  </v-row>
                </td>
                <td class="caption text-center">{{ item.currency }}</td>
                <td>
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon x-small @click="onToggleTrash(item)">
                        <v-icon size="20" :color="item.trash ? 'error' : 'grey'"
                          >mdi-delete</v-icon
                        >
                      </v-btn>
                    </template>
                    {{ item.trash ? "Untrash country" : "Tash country" }}
                  </v-tooltip>
                </td>
                <td>
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon x-small @click="onUpdateCountry(item)">
                        <v-icon size="20" color="primary">mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    Edit country
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogUpdateItem" persistent max-width="800px">
      <v-row no-gutters>
        <v-col>
          <v-card color="white" flat tile>
            <v-card-title class="dialog-header-title">{{ titleDialog }}</v-card-title>

            <v-divider></v-divider>
            <!-- <v-alert v-model="alert" :type="alertType" dismissible>{{
              alertMessage
            }}</v-alert> -->
            <v-card-text v-if="country != null" class="pb-1">
              <v-row dense>
                <v-col>
                  <span>Country Name</span>
                  <input class="form-control" v-model="country.name" />
                </v-col>

                <v-col cols="3">
                  <span>Country Code</span>
                  <input
                    class="form-control"
                    :disabled="isUpdate"
                    v-model="country.code"
                  />
                </v-col>

                <v-col cols="3">
                  <span>Currency</span>
                  <v-select
                    :items="currencies"
                    solo
                    flat
                    class="form-control"
                    v-model="country.currency"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider class="my-1"></v-divider>

            <v-card-actions>
              <v-row justify="end">
                <v-btn
                  v-show="isCreate"
                  @click="createCountry"
                  class="font-weight-bold mr-2 text-button"
                  color="primary"
                  tile
                  depressed
                  small
                  >CREATE</v-btn
                >

                <v-btn
                  v-show="isUpdate"
                  @click="updateCountry"
                  class="font-weight-bold mr-2 text-button"
                  color="primary"
                  tile
                  depressed
                  small
                  >SAVE</v-btn
                >

                <v-btn
                  @click="onCloseDialog"
                  class="font-weight-bold ml-2 text-button"
                  color="error"
                  tile
                  depressed
                  small
                  >CLOSE</v-btn
                >
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-dialog>
  </v-row>
</template>

<script>
import constant from "@/const";
// import GMapView from "@/components/shared/GMapView.vue"
export default {
  components: {
    // GMapView
  },
  data() {
    return {
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,
      alert: false,
      alertType: "success",
      alertMessage: "",
      CONSTANT: constant,

      searchTable: null,

      headers: [
        { text: "Name", value: "name", align: "left", sortable: true },
        {
          text: "Code",
          value: "code",
          align: "center",
          sortable: true,
        },
        {
          text: "Geocode",
          value: "geocode",
          align: "left",
          sortable: false,
        },
        {
          text: "Currency",
          value: "currency",
          align: "center",
          sortable: true,
        },
        {
          text: "Trashed",
          value: "trash",
          align: "center",
          sortable: true,
        },
        {
          text: "",
          align: "center",
          sortable: false,
        },
      ],

      countries: [],
      country: null,
      country_sync: {},
      currencies: [],

      isCreate: false,
      isUpdate: false,
      dialogUpdateItem: false,
      titleDialog: "Add new country",
    };
  },

  async created() {
    this.$root.blockUImsg = "please wait...";
    this.$root.blockUIshow = true;
    // verify user token
    await this.$root.verify_user_token();

    this.$root.blockUIshow = false;
  },

  mounted() {},

  watch: {},

  methods: {
    /**
     * load countries
     */
    async loadCountries() {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.get(`/api/countries`);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.countries = resp.data.data;
      } else {
        this.countries = [];
      }

      this.$root.blockUIshow = false;
    },

    /**
     * Get currencies list
     */
    async loadCurrenciesList() {
      var resp = await this.$https.get("/api/currencies/list/dropdown");
      this.currencies = resp.data.data || [];
    },

    /**
     * on create new country
     */
    async onNewItem() {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.get(`/api/geography/init/country`);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.country = resp.data.data;
        // fetch currencies
        this.loadCurrenciesList();

        this.isCreate = true;
        this.isUpdate = false;
        this.titleDialog = "Add new country";
        this.dialogUpdateItem = true;
      } else {
        this.country = null;
      }

      this.$root.blockUIshow = false;
    },

    /**
     * on update country
     */
    async onUpdateCountry(country) {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.get(`/api/country/${country.code}`);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // clone
        this.country_sync = country;
        this.country = resp.data.data;

        // fetch currencies
        this.loadCurrenciesList();

        this.titleDialog = "Edit country";
        this.isCreate = false;
        this.isUpdate = true;
        this.dialogUpdateItem = true;
      } else {
        this.country = null;
      }

      this.$root.blockUIshow = false;
    },

    /**
     * create country
     */
    async createCountry() {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.post(
        `/api/country/${this.country.code}`,
        this.country
      );
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.country = null;
        this.countries.push(resp.data.data);

        this.dialogUpdateItem = false;
        this.isCreate = false;
        this.isUpdate = false;

        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }

      this.$root.blockUIshow = false;
    },

    /**
     * update country
     */
    async updateCountry() {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.put(`/api/country/${this.country.code}`, this.country);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.country = null;
        // sync the updated data
        this.country_sync = Object.assign(this.country_sync, resp.data.data);

        // this.dialogUpdateItem = false
        this.isCreate = false;
        this.isUpdate = false;

        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }

      this.$root.blockUIshow = false;
    },

    /**
     * On trash or untrash country
     */
    async onToggleTrash(country) {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      let resp = null;

      if (country.trash) {
        resp = await this.$https.post(`/api/country/${country.code}/restore`);
        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          country.trash = false;
          this.showSnackbar = true;
          this.snackbarColor = "success";
          this.snackbarMsg = resp.data.msg;
        } else {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = resp.data.msg;
        }
      } else {
        resp = await this.$https.delete(`/api/country/${country.code}`);
        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          country.trash = true;
          this.showSnackbar = true;
          this.snackbarColor = "success";
          this.snackbarMsg = resp.data.msg;
        } else {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = resp.data.msg;
        }
      }

      this.$root.blockUIshow = false;
    },

    /**
     * close dialog and refresh
     */
    onCloseDialog() {
      //close the dialog
      this.dialogUpdateItem = false;
      this.isCreate = false;
      this.isUpdate = false;
    },
  },

  computed: {},
};
</script>

<style scoped>
.v-data-table {
  border: 2px solid #e0e0e0;
}
::v-deep .v-data-table thead tr th {
  text-align: center;
  text-transform: none;
  color: black !important;
  font-weight: bold;
  border: 1px;
  padding: 2px 0.2rem;
  height: 20px !important;
  line-height: 30px;
}
</style>
